import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../domain/users/user.model';
import { UserType } from '../domain/users/user-type.model';
import { UserUtils } from '../domain/users/user-utils.model';
import { Utils } from '../utils/utils';

@Injectable()
export class UsersService {

  constructor(private httpClient: HttpClient) {
  }

  getUsersByType(type: UserType): Observable<User[]> {
    return new Observable<User[]>(subscriber => {
      this.getUsers().subscribe(users => {
        users = users.filter(u => {
          UserUtils.setType(u);
          return u._type === type;
        });
        users.sort(Utils.sortComparatorByAttribute('name'));
        subscriber.next(users);
      }, (e) => subscriber.error(e), () => subscriber.complete());
    });
  }

  getUsers(): Observable<User[]> {
    return this.httpClient.get<User[]>(`${environment.serviceUrl}/ad-stats/ums/users`);
  }

  createUser(user: User): Observable<User> {
    return this.httpClient.post<User>(`${environment.serviceUrl}/ums/users/create`, user);
  }

  updateUser(user: User): Observable<User> {
    return this.httpClient.put<User>(`${environment.serviceUrl}/ums/users/${user.id}`, user);
  }

  deleteUser(user: User): Observable<User> {
    return this.httpClient.delete<User>(`${environment.serviceUrl}/ums/users/delete?username=${user.username}`);
  }

  getById(id: string): Observable<User> {
    return this.httpClient.get<User>(`${environment.serviceUrl}/ad-stats/ums/users/${id}`);
  }

  getByPublisherId(publisherId: string): Observable<User[]> {
    return this.httpClient.get<User[]>(`${environment.serviceUrl}/ums/users-by-publisher?publisherId=${publisherId}`);
  }

}
